export default __webpack_public_path__ + "static/media/search-movies-page-dark.9312a310.png";